package com.patronat.top.ui.components.molecules.header

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.atoms.AvatarCircle
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.LabelLarge
import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.MineShaft600
import com.patronat.top.ui.theme.MineShaft900

@Composable
fun UserProfileBlock(
    userName: String,
    userRole: String,
    initials: String,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.End
    ) {
        AvatarCircle(
            initials = initials
        )

        Spacer(modifier = Modifier.width(12.dp))

        Column(horizontalAlignment = Alignment.Start) {
            Text(
                text = userName,
                style = BodyMedium.copy(fontSize = 13.sp, lineHeight = 20.sp, color = MineShaft900),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = userRole,
                style = BodyMedium.copy(fontSize = 10.sp, lineHeight = 15.sp, color = MineShaft500),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}